import Axios from 'axios';
import * as AccountRequest from '@/models/accountRequest';
import * as AccountResponse from '@/models/accountResponse';

export type Owner = AccountResponse.OwnerAccountDetailResponse;

export interface SearchCondition {
  keyWord: string;
  perPage: number;
  page: number;
  sort: string;
}

interface State {
  loading: boolean;
  countAll: number;
  users: Owner[];
  searchCondition: SearchCondition;
}
const mapState: State = {
  loading: false,
  countAll: 0,
  users: new Array<Owner>(),
  searchCondition: {
    keyWord: '',
    perPage: 20,
    page: 1,
    sort: '',
  },
};

const mapActions = {
  async searchUsers({ dispatch, commit }: any, searchCondition: SearchCondition) {
    commit('setLoading', true);
    const data = await dispatch('getUsers', searchCondition).catch((error: any) => {
      commit('setLoading', false);
      throw error;
    });
    commit('searchUsers', data);
  },
  async getUsers({ commit }: any, searchCondition: SearchCondition) {
    const request: AccountRequest.OwnerAccountRequest = {
      id: undefined,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      note: undefined,
      keyWord: searchCondition.keyWord,
      perPage: searchCondition.perPage,
      page: searchCondition.page,
      sort: searchCondition.sort,
    };
    const response = await Axios.post('/api/Account/OwnerSearch', request).catch((error) => {
      throw error;
    });
    return response.data;
  },
  async createUser({ commit }: any, user: Owner) {
    if (!user || !user.lastName || !user.firstName) {
      throw new Error('氏名を入力してください。');
    }
    if (!user.lastNameKana || !user.firstNameKana) {
      throw new Error('カナ氏名を入力してください。');
    }
    const request: AccountRequest.OwnerAccountRequest = {
      id: undefined,
      userId: user.userId,
      lastName: user.lastName,
      firstName: user.firstName,
      lastNameKana: user.lastNameKana,
      firstNameKana: user.firstNameKana,
      note: user.note,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/OwnerCreate', request).catch((error) => {
      throw new Error('オーナーの登録に失敗しました。');
    });
    return response.data;
  },
  async editUser({ commit }: any, user: Owner) {
    if (!user || !user.id) {
      throw new Error('変更するオーナーを選択してください。');
    }
    if (!user || !user.lastName || !user.firstName) {
      throw new Error('氏名を入力してください。');
    }
    if (!user.lastNameKana || !user.firstNameKana) {
      throw new Error('カナ氏名を入力してください。');
    }
    const request: AccountRequest.OwnerAccountRequest = {
      id: user.id,
      userId: user.userId,
      lastName: user.lastName,
      firstName: user.firstName,
      lastNameKana: user.lastNameKana,
      firstNameKana: user.firstNameKana,
      note: user.note,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/OwnerEdit', request).catch((error) => {
      throw new Error('オーナーの変更に失敗しました。');
    });
    commit('changeUser', user);
    return response.data;
  },
  async deleteUser({ commit }: any, id: string) {
    if (!id) {
      throw new Error('削除するオーナーを選択してください。');
    }
    const request: AccountRequest.OwnerAccountRequest = {
      id,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      note: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/OwnerDelete', request).catch((error) => {
      throw new Error('オーナーの削除に失敗しました。');
    });
    commit('removeUser', id);
    return response.data;
  },
  async resetPassword({ commit }: any, id: string) {
    if (!id) {
      throw new Error('パスワード初期化するオーナーを選択してください。');
    }
    const request: AccountRequest.OwnerAccountRequest = {
      id,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      note: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/Reset', request).catch((error) => {
      throw new Error('パスワードの初期化に失敗しました。');
    });
    return response.data;
  },
  async getUser({ commit }: any, id: string) {
    const request: AccountRequest.OwnerAccountRequest = {
      id,
      userId: undefined,
      lastName: undefined,
      firstName: undefined,
      lastNameKana: undefined,
      firstNameKana: undefined,
      note: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
    };
    const response = await Axios.post('/api/Account/OwnerDetail', request).catch((error) => {
      throw error;
    });
    return response.data as Owner;
  },
};

const mapMutations = {
  setLoading(state: State, loading: boolean) {
    state.loading = loading;
  },
  searchUsers(state: State, data: AccountResponse.OwnerAccountListResponse) {
    state.countAll = data.countAll;
    state.users = data.accountList;
    state.loading = false;
  },
  changeUser(state: State, user: Owner) {
    const findIndex = state.users.findIndex((value) => {
      return (value.id === user.id);
    });
    if (findIndex >= 0) {
      state.users.splice(findIndex, 1, user);
    }
  },
  removeUser(state: State, id: string) {
    const findIndex = state.users.findIndex((value) => {
      return (value.id === id);
    });
    if (findIndex >= 0) {
      state.users.splice(findIndex, 1);
    }
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
